import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { IconButton, Text, useTheme } from "react-native-paper";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { RootStackParamList } from "../../types/navigationParams";
import { useTranslation } from "react-i18next";
import { Config, Field } from "../../config/companies/config";

interface PaymentsFieldProps {
  config: Config;
  onChange: (fieldName: string, newValue: any) => void;
  field: Field;
  value: any;
}

export const PaymentsField = ({
  config,
  onChange,
  field,
  value,
}: PaymentsFieldProps) => {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { t } = useTranslation();
  const theme = useTheme();

  const paymentCollection = config.database.find(
    (c: any) => c.name === "payments",
  );

  const navToPaymentsForm = () => {
    if (paymentCollection) {
      navigation.navigate("PaymentsFormScreen", {
        collection: paymentCollection,
        onNewDocumentCallback: (newPayment: any) => {
          if (Array.isArray(value)) {
            const updatedPayments = [...value, newPayment];
            onChange(field.name, updatedPayments);
          } else {
            onChange(field.name, [newPayment]);
          }
        },
      });
    }
  };

  const handleDeletePayment = (indexToDelete: number) => {
    if (Array.isArray(value)) {
      const updatedPayments = value.filter(
        (_, index) => index !== indexToDelete,
      );
      onChange(field.name, updatedPayments);
    }
  };

  const handleEditPayment = (paymentToEdit: any, index: number) => {
    if (paymentCollection) {
      navigation.navigate("PaymentsFormScreen", {
        collection: paymentCollection,
        existingItem: paymentToEdit,
        onNewDocumentCallback: (newPayment: any) => {
          const updatedPayments = [...value];
          updatedPayments[index] = newPayment;
          onChange(field.name, updatedPayments);
        },
      });
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text variant="titleMedium">{t(field?.label)}</Text>
        <IconButton icon="plus-circle" onPress={navToPaymentsForm} />
      </View>
      <View>
        {Array.isArray(value) &&
          value.map((item, index) => (
            <View
              key={index}
              style={[
                styles.paymentItemContainer,
                { borderColor: theme.colors.outline },
              ]}
            >
              <View style={styles.paymentItemTextContainer}>
                <Text>
                  {t("paymentType")}: {t(item.paymentType)}
                </Text>
                <Text>
                  {t("paymentAmount")}: {item.paymentAmount}
                </Text>
              </View>
              <View style={styles.paymentItemActionsContainer}>
                <IconButton
                  icon="pencil"
                  size={20}
                  onPress={() => handleEditPayment(item, index)}
                />
                <IconButton
                  icon="delete"
                  size={20}
                  onPress={() => handleDeletePayment(index)}
                />
              </View>
            </View>
          ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  paymentItemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 8,
    borderBottomWidth: 1,
  },
  paymentItemTextContainer: {
    flex: 1,
  },
  paymentItemActionsContainer: {
    flexDirection: "row",
  },
});
